<template>
  <div class="w-full text-center">
    <div class="content">
      <div style="margin-bottom: 100px" class="flex flex-wrap mb-4">
        <div class="w-full md:w-1/3"></div>
        <div class="w-full md:w-1/3">
          <h1 class="mb-6 text-center big-title">
            Complimenti!
          </h1>

          <p class="text-center">
            La richiesta carta è stata approvata!
          </p>

          <img
            class="reg-completed-img"
            src="../../assets/images/conto_ok.png"
          />

          <div class="info-box">
            <p class="text-grey mt-10">
              Provvederemo ad emettere e spedire la tua carta prepagata.
            </p>
          </div>
        </div>
        <div class="w-full md:w-1/3">
          <div
            v-if="userIsRequestingInfluencerCard === false"
            class="info-card-box"
          >
            <div class="card">
              <img v-if="cardImage" class="card-img" :src="cardImage" />

              <div class="card__box md:w-1/2 m-center p-5 rounded">
                <p class="f-b mt-10 mb-3">
                  Riceverai la tua carta Tinaba all'indirizzo che hai indicato e
                  potrai iniziare subito ad utilizzarla!
                </p>
                <p class="text-grey">
                  La carta Tinaba è una carta prepagata contactless,
                  ricaricabile direttamente dall'app. La ricarica è istantanea e
                  gratuita. Puoi scegliere di ricaricare dal tuo conto, dai
                  gruppi Tinaba e dai progetti privati. Puoi inoltre
                  associarla a Samsung Pay, Apple Pay, Google Pay, Garmin Pay,
                  Fitbit Pay e SwatchPay!
                  <br /><br />È utilizzabile per qualsiasi pagamento in punti
                  vendita fisici e online e per prelevare contanti presso gli
                  sportelli atm di tutto il mondo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- wait until userSubscribedAnyPlan is evalued -->
    <div v-if="userSubscribedAnyPlan !== null" class="page-footer">
      <!-- if user requested an influencer card but still doesn't have the related plan
          we redirect him to the plan activation page -->
      <button
        v-if="userIsRequestingInfluencerCard && !userSubscribedAnyPlan"
        class="btn"
        @click="goToProfileActivation"
      >
        Ho capito
      </button>
      <button v-else class="btn" @click="backToInitialView">
        Torna alla schermata iniziale
      </button>
    </div>
  </div>
</template>

<script>
import UtilityService from "@/services/UtilityService";
import ApiService from "@/services/ApiService";
import RegistrationService from "@/services/RegistrationService";

export default {
  name: "MinorRegistrationCompleted",

  data() {
    return {
      userSubscribedAnyPlan: null,
      cardImage: null
    };
  },
  computed: {
    userIsRequestingInfluencerCard: function() {
      return (
        this.$store.state.registrations?.prepaidCardResource?.profile &&
        this.$store.state.registrations?.prepaidCardResource?.profile !== "BASE"
      );
    }
  },
  async mounted() {
    if (this.$store.state.registrations.id !== undefined) {
      this.init();
    } else {
      this.$root.$on("appIsReady", this.init);
    }
  },
  methods: {
    async init() {
      this.isUpgrade = sessionStorage.getItem("upgrade") !== null;
      this.userSubscribedAnyPlan = await RegistrationService.userSubscribedAnyPlan();

      this.$root.$emit("openGlobalLoader");
      try {
        const response = await ApiService.get(`/usr/v2/prepaid-cards/`);
        this.currentCard = response.data?.filter(
          c => c.id === this.$store.state.registrations.prepaidCardResource.id
        )[0];
        this.$root.$emit("closeGlobalLoader");
      } catch (error) {
        this.$root.$emit("closeGlobalLoader");
        UtilityService.showDefaultError(error);
      }
      this.setCardImage();
    },
    setCardImage() {
      this.cardImage =
        this.currentCard && this.currentCard.content?.imagesUrl?.front
          ? this.currentCard.content.imagesUrl.front
          : require("@/assets/images/carta-tinaba.png");
    },
    goToProfileActivation() {
      UtilityService.goToProfileActivation(this.currentCard.id);
    },
    backToInitialView() {
      UtilityService.backToInitialView();
    }
  }
};
</script>
<style lang="less" scoped>
.reg-completed-img {
  width: 200px;
  margin: 20px auto;
}
.info-box {
  text-align: left;
  max-width: 515px;
  p {
    margin-bottom: 22px;
  }
  ul {
    margin-left: 20px;
    list-style: initial;
  }
}
.info-card-box {
  margin-top: 100px;
  display: flex;
  height: 100%;
  align-items: center;
  text-align: left;
  @media (max-width: 768px) {
    margin-top: 80px;
  }
  .card {
    position: relative;
    .card__box {
      width: 300px;
    }
  }
  img {
    width: 200px;
    position: absolute;
    top: -90px;
    left: 100px;
  }
}
</style>
